import React, { useState } from 'react';
import { normalizeTimestamp, isMilliseconds, formatSafeDate } from '../utils/timeUtils';

const Batch: React.FC = () => {
  const [mode, setMode] = useState<'TS_TO_DATE' | 'DATE_TO_TS'>('TS_TO_DATE');
  const [input, setInput] = useState<string>('');
  
  const process = () => {
    const lines = input.split('\n');
    return lines.map(line => {
      const trimmed = line.trim();
      if (!trimmed) return '';
      
      try {
        if (mode === 'TS_TO_DATE') {
          const ts = parseInt(trimmed);
          if (isNaN(ts)) return 'Invalid Timestamp';
          const isMs = isMilliseconds(ts);
          const date = new Date(isMs ? ts : ts * 1000);
          return formatSafeDate(date, 'yyyy-MM-dd HH:mm:ss') + (isMs ? ' (ms)' : '');
        } else {
          // Date to TS
          const date = new Date(trimmed);
          if (isNaN(date.getTime())) return 'Invalid Date';
          return Math.floor(date.getTime() / 1000).toString();
        }
      } catch (e) {
        return 'Error';
      }
    }).join('\n');
  };

  const output = process();

  return (
    <div className="h-[calc(100vh-200px)] flex flex-col">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-slate-800">Batch Converter</h2>
        <div className="flex bg-white rounded-lg p-1 border border-slate-200">
          <button 
            onClick={() => setMode('TS_TO_DATE')}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${mode === 'TS_TO_DATE' ? 'bg-sky-500 text-white' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            Timestamp to Date
          </button>
          <button 
            onClick={() => setMode('DATE_TO_TS')}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${mode === 'DATE_TO_TS' ? 'bg-sky-500 text-white' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            Date to Timestamp
          </button>
        </div>
      </div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
        <div className="flex flex-col">
          <label className="text-sm font-semibold text-slate-600 mb-2">Input (One per line)</label>
          <textarea
            className="flex-1 w-full p-4 bg-white border border-slate-300 rounded-lg resize-none font-mono text-sm outline-none focus:ring-2 focus:ring-sky-500"
            placeholder={mode === 'TS_TO_DATE' ? "1672531200\n1680307200" : "2023-01-01 00:00:00\nOct 15 2023"}
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <label className="text-sm font-semibold text-slate-600 mb-2">Result</label>
          <textarea
            readOnly
            className="flex-1 w-full p-4 border border-slate-300 bg-slate-50 rounded-lg resize-none font-mono text-sm outline-none text-slate-700"
            value={output}
          />
        </div>
      </div>
    </div>
  );
};

export default Batch;